
    class ResetRequest {
        userId: number;
        newPassword: string;
    }
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import User from '../../../store/entities/user'
    import Enums from '@/lib/enums'
    @Component
    export default class EditUser extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        user: User = new User();
        reset: ResetRequest = new ResetRequest();
        
        created() {
            
        }
        save() {
            (this.$refs.resetForm as any).validate(async (valid: boolean) => {
                this.reset.userId = this.$store.state.user.id
                if (valid) {
                        await this.$store.dispatch({
                            type: 'user/resetPassword',
                            data: this.reset
                        });
                        (this.$refs.resetForm as any).resetFields();
                        this.$emit('save-success');
                        this.$emit('input', false);
                }
            })
        }
        cancel() {
            (this.$refs.resetForm as any).resetFields();
            this.$emit('input', false);
        }
        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
                
            }
        }
        resetRule = {
            newpassword: [{ required: true, message: "用户重置密码不能为空", trigger: 'blur' }],
            adminPassword: [{ required: true, message: "管理员密码不能为空", trigger: 'blur' }],
        }

    }
